import { Component } from '@angular/core';
import { NavController, ViewController, NavParams  } from 'ionic-angular';
import { ModalController } from 'ionic-angular';



@Component({
  selector: 'page-certificateModal',
  templateUrl: 'certificateModal.html',
  // styleUrls: ['certificateModal.scss', '../../../theme/variables.scss']
})
export class CertificateModalPage {

  public display: any;



  constructor(public navCtrl: NavController, public viewCtrl: ViewController, public navParams: NavParams) {
    this.display = this.navParams.get("display");
  }

  dismiss() {
   this.viewCtrl.dismiss();
 }

  seeValue(display){
    console.log(display);
  }

}


// WEBPACK FOOTER //
// ./src/pages/certificate/certificateModal/certificateModal.ts